<template>
    <div class="acupuncture-page">
      <!-- 主体分栏区域 -->
      <el-row :gutter="20">
        <el-col>
          <el-card>
            <template #header>
              <h2>AKUPUNKTUR I KINA:</h2>
            </template>
            <ul>
              <li v-for="(item, index) in chinaContent" :key="index" style="list-style: none;">
                <!-- 如果是小标题，用 h3 标签显示 -->
                <h3 v-if="['Utbildning', 'Läkarcertifikat', 'Akupunktur på sjukhus'].includes(item)">{{ item }}</h3>
                <span v-else>{{ item }}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col style="margin-top: 15px;">
          <el-card>
            <template #header>
              <h2>AKUPUNKTUR I SVERIGE:</h2>
            </template>
            <!-- 添加类名 sweden-content-list -->
            <ul class="sweden-content-list">
              <li v-for="(item, index) in swedenContent" :key="index">{{ item }}</li>
            </ul>
          </el-card>
        </el-col>
      </el-row>
      <!-- 底部图片区域 -->
      <div class="bottom-image">
        <el-carousel :interval="4000" arrow="always">
          <el-carousel-item v-for="(image, index) in carouselImages" :key="index">
            <el-image :src="image" alt="acupuncture-image" style="max-width: 100%;"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "AcupuncturePage",
    data() {
      return {
        // 轮播图图片路径数组
        carouselImages: [
          require("@/assets/akupunkturIKina/banner1.jpg"),
          require("@/assets/akupunkturIKina/banner2.jpg"),
          require("@/assets/akupunkturIKina/banner3.jpg"),
          require("@/assets/akupunkturIKina/banner4.jpg")
        ],
        // 中国针灸相关内容
        chinaContent: [
          "Utbildning",
          "I Kina delas lakarutbildningen i två olika typer som traditionell kinesisk medicin och västerländsk ",
          "läkarutbildning. TKM lakarutbildningen består av fem års grundutbildning, tre års ",
          "masterutbildning och tre års doktorutbildning. När studenterna klarar av TKM examen (inklusive ",
          "intensiv akupunktur) kan de ta examen på kandidat examen.",
          "TKM studenterna behöver även lära sig västerländska kunsker som anatomi, fysiologi, patologi, ",
          "intermedicin, kirurgi, gynekologi, barnsjukdomar och dermatologi utbildningar för TKM studenter.",
          "Läkarcertifikat",
          "Enligt kinesisk lag måste en person som arbetar med akupunkturbehandlingar ha läkarcertifikat för att ",
          "arbeta eller avläsa behandlingar utan framläggning.",
          "Akupunktur på sjukhus",
          "De flesta sjukhus har specialiserade akupunkturavdelningar och öppna svenska-övergångsbehandlingar. ",
          "Läkare använder både traditionell kinesisk medicin och västerländska undersökningsresultat för att ställa ",
          "diagnos och använda akupunktur för att behandla dessa sjukdomar."
        ],
        // 瑞典针灸相关内容，按段落划分
        swedenContent: [
          "I Sverige är akupunktur och traditionell kinesisk medicin fortfarande omgiven av lite mysterium och okänt för de flesta.",
          "Många har provat akupunktur - ofta som en sista möjlighet efter att ha gått igenom det svenska medicinska systemet och andra alternativa behandlingar utan framgång.",
          "Det är en fel inställning att betrakta akupunktur som en sista utväg - i själva verket kan akupunktur åtgärda akuta sjukdomar och förebygga livsstilssjukdomar såväl som kroniska sjukdomar (smärta etc.)",
          "Det finns ingen officiell kontroll över akupunkturkliniker i Sverige. Det innebär att alla kan öppna en klinik och behandla patienter. Detta har bidragit till att ge ett felaktigt intryck av akupunktur, som faktiskt är en vetenskap på hög nivå.",
          "Akupunktur är inte farlig när den utförs professionellt och fysiskt korrekt. Detta innebär att terapeuten behöver kunskap om bland annat kroppens anatomi och sjukdomar och att de förstår vad sjukdomarna medför."
        ]
      };
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .acupuncture-page {
    min-width: 1200px; 
    width: 1200px; 
    font-family: Arial, sans-serif;
    padding: 20px;
    // 添加背景图片样式
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  
    .top-decoration {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }
  
    .bottom-image {
      text-align: center;
      margin-top: 20px;
    }
  
    // 设置 ul 列表的文本左对齐
    ul {
      text-align: left;
      padding-left: 20px; // 可选：添加内边距使列表项有一定的缩进
    }
  
    // 给 el-card 添加背景图片
    .el-card {
      background-image: url('@/assets/bg.jpg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  </style>